// extracted by mini-css-extract-plugin
export default {"head":"HomeSectionHead_head__Teo-g","title":"HomeSectionHead_title__niQmZ","action":"HomeSectionHead_action__uytnv"};